import { getAuth } from "firebase/auth";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addClaim, addClaimNote, getClaimNotes } from "../firebase/controller/property";
import { getClaims, getFiles, getTotalUsed, uploadDocuments } from "../firebase/controller/vault";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { uploadMultipleClaim } from "../utils";

const VaultContext = React.createContext();

export function useVault() {
  return useContext(VaultContext);
}

export function VaultProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [files, setFiles] = useState([]);
  const [total, setTotal] = useState(0);
  const [claims, setClaims] = useState([]);
  const [claimnotes, setClaimNotes] = useState([]);
  const [claim] = useState(null);
  const [loader, setLoader] = useState(false);
  const [noteLoader, setNoteLoader] = useState(false);
  const [mediaURLs, setMediaURLs] = useState([]);
  const [uploadImage, setUploadImage] = useState(null);
  const [values, setValues] = useState();
  const dispatch = useDispatch();

  const [selectedClaim, setSelectedClaim] = useState();

  const uploaddocuments = async (values) => {
    try {
      setLoading(true);
      const res = await uploadDocuments(values);
      setDone(true);
      await getfiles(values?.documentType);
      await getTotal();
      res && toast.success("document added successfully.");
      setLoading(false);
    } catch (error) {
      toast.error("There is an error adding property, try again");
      setDone(true);
      setLoading(false);
      console.log(error.message);
    }
  };

  const getfiles = async (documentType = "insuranceDocuments") => {
    try {
      setLoading(true);
      const res = await getFiles(documentType);
      setFiles(res);
      setLoading(false);
    } catch (error) {
      const message = error.message;
      toast.error(message);
      setLoading(false);
    }
  };

  const getTotal = async () => {
    try {
      const res = await getTotalUsed();
      setTotal(res);
    } catch (error) {
      const message = error.message;
      toast.error(message);
    }
  };
  const getclaims = async () => {
    try {
      dispatch(openModal());
      const res = await getClaims();
      setClaims(res);
      dispatch(closeModal());
    } catch (error) {
      dispatch(closeModal());
      const message = error.message;
      toast.error(message);
    }
  };

  const addclaim = useCallback(
    async (status) => {
      if (uploadImage) {
        uploadMultipleClaim(uploadImage, mediaURLs, setMediaURLs, setLoader, status, async () => {
          const res = await addClaim(values, mediaURLs);
          res && toast.success("Claim added successfully.");
          setDone(true);
          setLoader(false);
        });
      }
    },
    [uploadImage, mediaURLs, values]
  );

  const addwithoutmedia = async (claim) => {
    try {
      setLoader(true);
      const res = await addClaim(claim);
      res && toast.success("Claim added successfully.");
      setLoader(false);
    } catch (error) {
      console.log(error.message);
      toast.error("There is an error adding claim, try again");
      setLoader(false);
    }
  };

  const getclaimnotes = async (claimName) => {
    try {
      setNoteLoader(true);
      const res = await getClaimNotes(claimName);
      setClaimNotes(res);
      setNoteLoader(false);
    } catch (error) {
      setNoteLoader(false);
      const message = error.message;
      toast.error(message);
    }
  };

  const addclaimnote = async (data) => {
    try {
      setLoading(true);
      const res = await addClaimNote(data);
      res && toast.success("Claim note  successfully.");
      setLoading(false);
      setDone(true);
    } catch (error) {
      toast.error("There is an error adding claim, try again");
      console.log(error.message);
      setLoading(false);
      setDone(true);
    }
  };

  useEffect(() => {
    (async function () {
      if (uploadImage && mediaURLs.length === Array.from(uploadImage).length) {
        await addclaim(true);
      }
    })();
  }, [addclaim, mediaURLs.length, uploadImage]);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged((user) => {
      if (user) {
        getfiles();
        getTotal();
        getclaims();
      }
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (claims.length > 0) {
      getclaimnotes(claims[0].claimName);
    }
  }, [claims]);

  const value = {
    loading,
    setLoading,
    uploaddocuments,
    done,
    setDone,
    getfiles,
    files,
    total,
    addclaim,
    setUploadImage,
    setValues,
    loader,
    claims,
    claim,
    addclaimnote,
    getclaims,
    setSelectedClaim,
    selectedClaim,
    getclaimnotes,
    claimnotes,
    noteLoader,
    addwithoutmedia,
    uploadImage,
  };

  return <VaultContext.Provider value={value}>{children}</VaultContext.Provider>;
}
